import React from "react"
import { injectIntl, FormattedMessage } from "react-intl"
import Dropzone from "react-dropzone-uploader"
import Preview from "../inputs/dropzone/Preview"
import {shallowEqual, useSelector} from "react-redux"
import { useSnackbar } from "notistack"
import {API_BASE_URL} from "../../../../../constants"


const ImportFrom = ({ maxFiles=3, intl, accept="application/*", url, multiple=false, onSubmit = f=>f }) => {

  const { enqueueSnackbar } = useSnackbar()
  const handleSubmit = (files, allFiles) => {
    onSubmit()
    allFiles.forEach(f => f.remove())
  }

  const { token, headerTokenType, audience } = useSelector(
    (state) => ({
      token: state.common.auth.token,
      headerTokenType: state.common.auth.headerTokenType,
      audience: state.common.auth.audience
    }),
    shallowEqual
  )

  const handleChangeStatus = ({ remove }, status) => {
    if (status === 'headers_received') {
      enqueueSnackbar(intl.formatMessage({ id: "GENERAL.UPLOAD_SUCCESS" }), {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        }
      })
      remove()
      onSubmit()
    } else if (status === 'aborted' || status === 'error_upload_params' || status === 'exception_upload' || status === 'error_upload') {
      enqueueSnackbar(intl.formatMessage({ id: "GENERAL.UPLOAD_FAILED" }), {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        }
      })
    }
  }

  const autoUpload = ({ file }) => {
    const body = new FormData()
    body.append('file', file)
    const tokenType = headerTokenType ? headerTokenType : 'Bearer'
    return { url: API_BASE_URL + url, body, headers: {"Authorization": `${tokenType}  ${token.access}`, "audience": audience} }
  }

  return (
    <div className="my-2 form-group">
      <Dropzone
        maxFiles={maxFiles}
        multiple={multiple}
        onChangeStatus={handleChangeStatus}
        accept={accept}
        getUploadParams={autoUpload}
        inputContent={<FormattedMessage key={1} id="GENERAL.UPLOAD_FILE_CONTENT" />}
        inputWithFilesContent={<FormattedMessage key={1} id="GENERAL.UPLOAD_FILE_INPUT" />}
        onSubmit={handleSubmit}
        PreviewComponent={Preview}
      />
    </div>
  )
}

export default injectIntl(ImportFrom)
